<template>
<div class="component dashboard">

    <div class="dashboardTitle">{{$t('enaq_translation_dashboard_title')}}</div>
    <br>

    <div class="tile is-ancestor">
        <div class="tile is-vertical is-8">

            <div class="tile is-parent">
                <article class="tile is-child notification is-info">

                    <p class="title">{{$t('enaq_translation_dashboard_consumption_title')}}</p>
                    <p class="subtitle">{{$t('enaq_translation_dashboard_consumption_subtitle')}}</p>
                    <div class="content">
                        ((Einzelne Geräte?))
                    </div>
                </article>
            </div>

            <div class="tile">

                <div class="tile is-parent is-vertical">

                    <fliptile :height="'250px'">
                        <template v-slot:front>
                            <article class="tile is-child notification is-dark">
                                <p class="title">{{$t('enaq_translation_dashboard_cardtitle_devices')}}</p>
                                <!-- <p class="subtitle">{{$t('enaq_translation_dashboard_cardsubtitle_devices')}}</p>-->

                                <div class="tileIcon">
                                    <div class="tileIconContainer"><i class="fas fa-tablet-alt"></i></div>
                                </div>

                            </article>
                        </template>

                        <template v-slot:back>
                            <article class="tile is-child notification is-dark">
                                <p class="title">{{$t('enaq_translation_dashboard_cardtitle_devices')}}</p>

                                <div class="columns is-mobile is-multiline">
                                    <div class="column is-12 dashboardDeviceBox" v-for="device in devices">
                                        <router-link class="deviceName" :to="{name:'devices',params:{selecteddeviceid:device.id}}">{{device.name}}

                                        </router-link>
                                        <span class="deviceKWH"> 1234 KWH</span>
                                    </div>
                                </div>
                            </article>
                        </template>

                    </fliptile>

                    <fliptile :height="'250px'">
                        <template v-slot:front>

                            <article class="tile is-child notification is-warning">
                                <p class="title">{{$t('enaq_translation_dashboard_cardtitle_overview')}}</p>

                                <div class="tileIcon">
                                    <div class="tileIconContainer"><i class="fas fa-map-marked-alt"></i></div>
                                </div>

                            </article>
                        </template>

                        <template v-slot:back>
                            <article class="tile is-child notification is-dark">
                                <div class="columns is-12 is-mobile is-multiline">
                                    <div class="column is-12">
                                        <p class="title">Karte</p>
                                        <router-link class="  " :to="'/map'">{{$t('enaq_translation_dashboard_subtitle')}}</router-link>

                                    </div>

                                </div>
                            </article>
                        </template>

                    </fliptile>

                </div>
                <!--
                <div class="tile is-parent">
                    <article class="tile is-child notification is-danger">
                        <p class="title">{{$t('enaq_translation_dashboard_groupmessages_title')}}</p>
                        <div v-for="message in groupMessages" class="columns is-mobile is-multiline">
                            <div class="column is-4">{{message.group.title}}</div>
                            <div class="column is-8">{{message.message.slice(0,70)}}</div>
                        </div>
                    </article>
                </div>
-->
                <div class="tile is-parent">
                    <article class="tile is-child notification is-danger">
                        <p class="title">{{$t('enaq_translation_dashboard_groupmessages_title')}}</p>

                        <div v-for="message in groupMessages" class="groupMessages">
                            <div class="groupTitle">{{message.group.title}}</div>
                            <div class="groupMessage">{{message.message.slice(0,70)}}</div>
                        </div>

                    </article>
                </div>
            </div>

        </div>
        <div class="tile is-parent">

            <article class="tile is-child notification is-success enaqGreen">

                <div class="content">
                    <p class="title">{{$t('enaq_translation_dashboard_cardtitle_messages')}}</p>
                    <p class="subtitle">{{$t('enaq_translation_dashboard_cardsubtitle_messages')}}</p>
                    <div class="content">
                        <announcement v-for="announcement in announcements" :announcement="announcement"></announcement>

                    </div>
                </div>
            </article>
        </div>
    </div>

</div>
</template>

<script>
import fliptile from '@/components/fliptile.vue'
import announcement from '@/components/Announcements/announcement.vue'

export default {
    name: 'Dashboard',
    props: ["refresh"],
    components: {
        fliptile,
        announcement
    },
    mounted: function () {
        if (this.refresh == true) {
            this.$router.push({
                name: 'dashboard',
                params: {
                    refresh: false
                }
            })

            this.$router.go();
        }
        this.getAnnouncements();
        this.getNewestGroupMessages();
        this.getDevices();
        this.testApiCall()
    },
    data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            data: [],
            announcementCount: 3,
            announcements: null,
            groupMessages: null,
            devices: null,
        }
    },
    methods: {
        getAnnouncements() {
            let headerData = {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.bearertoken
            }

            let postData = {
                amount: this.announcementCount
            }

            this.$axios.post(this.$backendURL + "/announcement/get", postData, {
                headers: headerData
            }).then(function (result) {
                this.announcements = result.data.announcements
            }.bind(this))
        },
        getNewestGroupMessages() {
            let headerData = {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.bearertoken
            }

            this.$axios.get(this.$backendURL + "/group/messages/new", {
                headers: headerData
            }).then(function (result) {
                this.groupMessages = result.data.messages
            }.bind(this))
        },
        sliceString(content, numberOfChars) {
            return content.slice(0, numberOfChars);
        },
        getDevices() {
            let headerData = {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.bearertoken
            }

            this.$axios.get(this.$backendURL + "/devices", {
                headers: headerData
            }).then(function (response) {

                if (response.data.devices.length > 0) {
                    this.devices = response.data.devices
                } else if (response.data.code == 3) {

                }

            }.bind(this))
        },
    },
    computed: {},
}
</script>

<style scoped>
.dashboard {
    margin-left: -5vw;
    margin-right: -5vw;
    padding: 0 2vw;
    margin-bottom: -20px;
    background: #3EAA0D;
    background: rgba(13, 0, 57, 1);
    background: #263369;
    background: #263369;
    min-height: 75vh;
}

.tile .is-child {
    background: #F7F7F7 !important;
    color: black;
}

.dashboardTitle {
    font-size: 3rem;
    color: white;
    font-weight: 600;
}

.dashboard_transition_bus-enter-to {
    transform: translateX(0);
}

.dashboard_transition_bus-enter {
    transform: translateX(-3500px);
}

.dashboard_transition_bus-enter-active,
.dashboard_transition_bus-leave-active {
    transition: all 3.4s;

}

.tile.is-child .title {
    border-bottom: 2px solid #162359;
}

.dashboard_transition_bus-enter,
.dashboard_transition_bus-leave-to {}

.flip-card {
    background-color: transparent;

    border: 1px solid #f1f1f1;
    perspective: 1000px;
    /* Remove this if you don't want the 3D effect */
}

/* This container is needed to position the front and back side */
.flip-card-inner {
    position: relative;
    width: 100%;
    height: 100%;
    text-align: center;
    transition: transform 0.8s;
    transform-style: preserve-3d;
}

/* Do an horizontal flip when you move the mouse over the flip box container */
.flip-card:hover .flip-card-inner {
    transform: rotateY(180deg);
}

/* Position the front and back side */
.flip-card-front,
.flip-card-back {
    position: absolute;
    width: 100%;
    height: 100%;
    backface-visibility: hidden;
}

/* Style the front side (fallback if image is missing) */
.flip-card-front {
    background-color: #bbb;
    color: black;
}

/* Style the back side */
.flip-card-back {
    background-color: dodgerblue;
    color: white;
    transform: rotateY(180deg);
}

.dashboardDeviceBox {
    display: block;
    border-bottom: 1px solid grey;
}

.tileIcon {
    position: relative;
    height: calc(100% - 3.5rem);
}

.tileIconContainer {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.tileIcon i {
    font-size: 9rem;

    min-height: 10rem;
    color: #3E9BD7;

}

.deviceName {
    display: inline-block;
    width: 50%;
}

.deviceKWH {
    display: inline-block;
    width: 50%;
}

.groupMessages {
    margin-bottom: 5px;
    background: #3E9BD7;
    color: white;
    border-radius: 10px;
    padding: 10px;
}

.groupTitle {
    text-align: left;
    line-height: 1em;
    margin-right: 1%;
    font-size: 1.2em;
    font-weight: bolder;
    margin-bottom: 0.5em;
}

.groupMessage {
    text-align: left;

    padding: 5px;
}
</style>
